import React, { FC } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { renderBeerRow } from "./ExciseServTableBeerRow";
import ExciseServTableSummary from "./ExciseServTableSummary";
import { InvoiceDataType } from "../../../api/invoice";

const ExciseServiceTable: FC<{ data?: InvoiceDataType }> = ({ data }) => {
  return (
    <TableContainer component={Paper}>
      <Table
        sx={{
          borderBottom: "3px solid black",
        }}
      >
        <TableHead>
          <TableRow
            sx={{
              borderBottom: "3px solid black",
            }}
          >
            {[
              {
                id: "service-description",
                label: "Service Description",
                width: "50%",
                borderRight: "3px solid black",
              },
              { id: "unit-keg", label: "Unit (Keg- L)" },
              { id: "unit-rate", label: "Unit Rate/Keg" },
              { id: "keg-nos", label: "Keg (Nos.)" },
              { id: "litres", label: "Litres" },
              { id: "amount", label: "Amount (Rs.)" },
            ].map(({ id, label, width, borderRight }) => (
              <TableCell
                key={id}
                id={id}
                scope="col"
                sx={{
                  textAlign: "center",
                  fontSize: "11px",
                  width,
                  borderRight,
                  "&.MuiTableCell-root.MuiTableCell-root": {
                    fontFamily: "Inter",
                  },
                }}
              >
                {label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {/* Render Beer rows with computed data */}
          {data?.excise?.products?.map((beer, index) => (
            <React.Fragment key={index}>
              {renderBeerRow(
                {
                  ...beer,
                  beerName: beer.name,
                  litres: beer.liters,
                  unitKegL: beer.unitKeg,
                  unitRatePerKeg: beer.unitRate,
                },
                index
              )}
            </React.Fragment>
          ))}

          {/* Render the Total,TCS,GrandTotal rows with computed data */}
          <ExciseServTableSummary
            totals={{
              totalKegNos: data?.excise?.kegNos,
              totalLitres: data?.excise?.liters,
            }}
            tcs={data?.excise?.tcs ?? 0}
            grandTotal={data?.excise?.grandTotal ?? 0}
          />

          <TableRow>
            <TableCell
              aria-labelledby="service-description"
              sx={{
                width: "50%",
                borderTop: "3px solid black",
                lineHeight: 2,
                fontSize: "10px",

                "&.MuiTableCell-root.MuiTableCell-root": {
                  paddingRight: "5px",
                  fontFamily: "Inter",
                },
              }}
              colSpan={6}
              data-testid="amount-in-words"
            >
              <span
                style={{
                  fontWeight: 500,
                  fontSize: "10px",
                  fontFamily: "Inter",
                }}
              >
                Amount in Words:{" "}
              </span>
              {data?.excise?.amountInWords}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ExciseServiceTable;
